import { render, staticRenderFns } from "./FileExporter.vue?vue&type=template&id=cf145da4&"
import script from "./FileExporter.vue?vue&type=script&lang=js&"
export * from "./FileExporter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports